import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_termination_forced_resignation_retrenchment_or_retirement_e'

export const dataPointDefinition = {
  retracedId: 'has_termination_forced_resignation_retrenchment_or_retirement_e',
  name: 'Has termination, forced resignation, retrenchment or retirement ever occurred due to a worker filing a complaint or taking part in proceedings against the facility?',
  description:
    'The intent of this question is to understand if workers, who actively filed a complaint or took part in a legal proceeding against the facility, were terminated for their actions/involvement. \r\r\n\r\r\n"Proceedings" here refers to the process of appearing before a court of law so a decision can be made about an argument or claim.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-13',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18110,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
